import { zodResolver } from '@hookform/resolvers/zod';
import { Form } from '@shared/components';
import { type PropsWithChildren } from '@shared/utils';
import { useEffect } from 'react';
import { FormProvider, useForm } from 'react-hook-form';

import { useRecurringExamEventCreation } from '../recurring-exam-event-creation-provider';

import {
  RecurringExamEventCreationFormSchema,
  type RecurringExamEventCreationFormType,
} from './schema';
import { getDefaultValues } from './utils';

export default function RecurringExamEventCreationFormProvider(props: Readonly<PropsWithChildren>) {
  const { examEvent } = useRecurringExamEventCreation();
  const formContext = useForm<RecurringExamEventCreationFormType>({
    defaultValues: getDefaultValues(examEvent ?? undefined),
    resolver: zodResolver(RecurringExamEventCreationFormSchema),
    mode: 'onSubmit',
  });
  const { watch, clearErrors } = formContext;

  useEffect(() => {
    const subscription = watch((_, { name }) => {
      if (name) {
        clearErrors(name);
      }
    });
    return () => subscription.unsubscribe();
  }, [watch, clearErrors]);

  useEffect(() => {
    formContext.reset(examEvent ?? undefined);
  }, [examEvent, formContext]);

  return (
    <FormProvider {...formContext}>
      <Form>{props.children}</Form>
    </FormProvider>
  );
}
